<template>
    <div class="home-page">
        <div v-if="showNotice" class="reminder">
            <span @click="openRouterDetail('notices', notice.id)">{{ notice.title }}</span>
            <img class="close" src="@/assets/images/homePage/index_close.png" alt="" @click="showNotice = false" />
        </div>
        <div class="banner">
            <Swipe :auto="2500" :speed="300">
                <SwipeItem v-for="item in swipers" :key="item.id">
                    <a :href="item.mobileLink || item.link" target="_blank">
                        <img
                            :src="item.cover && item.cover.url"
                            class="img"
                            :alt="item.cover && (item.cover.caption || item.cover.alternativeText || item.cover.url)"
                        />
                    </a>
                </SwipeItem>
            </Swipe>
        </div>
        <navs />
        <div class="express-delivery">
            <div class="title">
                物流服务介绍
                <a class="toAll" href="https://ucmp.sf-express.com/we/cx3.0/service-query">
                    查看全部
                    <img src="@/assets/images/homePage/arrow-red.png" alt="" />
                </a>
            </div>
            <ul class="select">
                <li
                    v-for="item in expressTypeArr"
                    :key="item.type"
                    :class="{ active: item.type === type }"
                    @click="handleExpressTypeChange(item.type)"
                >
                    {{ item.name }}
                </li>
            </ul>
            <div v-for="item in expressDeliveryMap[type]" :key="item.id" class="express-list-item" @click="openMobLink(item.mobileLink)">
                <img :src="item.cover && item.cover.url" alt="物流服务介绍" class="cover" />
                <div class="content">
                    <div class="title">
                        {{ item.title }}
                        <img src="@/assets/images/homePage/arrow-black.png" alt="" />
                    </div>
                    <div class="description">{{ item.description }}</div>
                </div>
            </div>
        </div>
        <div class="news">
            <div class="title">
                <span class="title-main">新闻资讯</span>
                <router-link class="toAll" to="news/list">
                    查看全部
                    <img src="@/assets/images/homePage/arrow-red.png" alt="" />
                </router-link>
            </div>
            <div class="new-list">
                <div v-for="item in newsArr" :key="item.id" class="new-list-item" @click="openRouterDetail('news', item.id)">
                    <!-- <img :src="item.cover && item.cover.url" alt="新闻资讯" class="cover" /> -->
                    <div class="content-title">
                        {{ item.title }}
                    </div>
                    <p class="description">
                        {{ item.description }}
                    </p>
                    <p class="day">{{ item.day }}</p>
                </div>
            </div>
        </div>
        <to-top></to-top>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import ajax from '@/api/ajax'
import { Swipe, SwipeItem } from 'mint-ui'
import navs from '@/components/header/components/navs'
import { expressTypeArr } from './config'
import toTop from '@/components/to-top'
export default {
    name: 'HomePage',
    components: {
        Swipe,
        SwipeItem,
        navs,
        toTop
    },
    props: {
        noHead: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            showNotice: false,
            swipers: [], // 轮播图
            notice: {}, // 服务公告
            expressTypeArr, // 快递服务类型数组
            expressDeliveryMap: {}, // 快递服务列表的map
            type: expressTypeArr[0].type, // 选中的快递服务类型
            newsArr: [], // 新闻列表
            isReminderOpen: false,
            isWarningOpen: false
        }
    },
    beforeCreate() {
        this.$store.commit('setTitle', this._ll('顺丰速运'))
    },
    async created() {
        // 获取封面图
        const HomeSwiperRes = await ajax.getHomeSwiper()
        this.swipers = HomeSwiperRes.swipers || []
        this.swipers = this.swipers.filter(item => item.cover && item.cover.url)
        // 获取新闻列表和物流服务
        const {
            express_delivery_cold_chains = [],
            express_delivery_freights = [],
            express_delivery_internationals = [],
            express_delivery_pharmaceuticals = [],
            express_delivery_services = [],
            news = [],
            notice = {}
        } = await this.getHomeConfig()
        this.newsArr = news
        this.notice = notice
        if (this.notice && Object.keys(this.notice).length > 0) {
            const { id = '' } = this.notice
            // 有数据id才展示公告
            this.showNotice = !!id
        }
        this.expressDeliveryMap = {
            express_delivery_cold_chains,
            express_delivery_freights,
            express_delivery_internationals,
            express_delivery_pharmaceuticals,
            express_delivery_services
        }
        this.setShowHeader(this.noHead !== 'true')
    },
    methods: {
        ...mapMutations({
            setShowHeader: 'setShowHeader'
        }),
        async getHomeConfig() {
            const result = await ajax.getHomeConfig()
            return result
        },
        handleExpressTypeChange(type) {
            this.type = type
        },
        openMobLink(link) {
            if (link) {
                window.open(link)
            }
        },
        openRouterDetail(module, id) {
            this.$router.push({
                name: `${module}Detail`,
                query: {
                    id
                }
            })
        },
        toggleShow(type) {
            this[`is${type}Open`] = !this[`is${type}Open`]
        }
    }
}
</script>

<style lang="scss" scoped>
.home-page {
    background: #fff;
    .reminder {
        padding: 0.15rem 0.68rem;
        background: #f2f2f2;
        font-size: 0.26rem;
        background-image: url('~@/assets/images/homePage/vector.png');
        background-size: 0.48rem;
        background-repeat: no-repeat;
        background-position: 0.2rem center;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .close {
            position: absolute;
            width: 0.5rem;
            right: 0.2rem;
            top: 50%;
            margin-top: -0.25rem;
        }
    }
    .banner {
        width: 100%;
        height: 470px;
        position: relative;
        overflow-x: hidden;
        .img {
            width: 100%;
            height: 100%;
        }
        >>> .mint-swipe-indicators {
            width: max-content;
            .mint-swipe-indicator {
                height: 6px;
                width: 12px;
                margin: 0 6px;
                opacity: 0.5;
                background: #fff;
                border-radius: 0;
                &.is-active {
                    width: 24px;
                    opacity: 1;
                }
            }
        }
    }
    .express-delivery {
        padding: 0 20px;
        margin-top: 48px;
        .title {
            font-size: 48px;
            color: #000;
            text-align: center;
            font-weight: 600;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .select {
            display: flex;
            background: #f2f3f8;
            margin-top: 32px;
            li {
                height: 80px;
                line-height: 80px;
                text-align: center;
                margin: 0;
                color: #676a71;
                flex: 1;
                &.active {
                    color: #ffffff;
                    background: #d2001c;
                    font-weight: 600;
                }
            }
        }
        .express-list-item {
            margin-top: 32px;
            border-radius: 12px;
            &:last-of-type {
                margin-top: 24px;
            }
            .cover {
                display: block;
                width: 100%;
                height: 400px;
                object-fit: cover;
            }
            .content {
                width: 100%;
                background: #f2f3f8;
                padding: 24px 30px;
                .title {
                    font-size: 32px;
                    color: #000;
                    font-weight: 600;
                    line-height: initial;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    img {
                        width: 32px;
                    }
                }
                .description {
                    display: flex;
                    justify-content: space-between;
                    font-size: 24px;
                    color: #676a71;
                    font-weight: 400;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
        }
    }
    .toAll {
        float: right;
        font-size: 24px;
        font-weight: 500;
        color: #d2001c;
        display: flex;
        align-items: flex-start;
        img {
            width: 32px;
            position: relative;
            top: 1px;
        }
    }
    .news {
        margin-top: 48px;
        padding: 0 0.2rem;
        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .title-main {
                font-size: 48px;
                color: #000;
                font-weight: 600;
                align-items: center;
            }
        }
        .new-list {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 32px;
            .new-list-item {
                width: 100%;
                padding: 24px;
                border-top: 1px solid #eee;
                padding: 24px 0;
                &:last-of-type {
                    padding-bottom: 0;
                }
                .content-title {
                    font-size: 32px;
                    font-weight: 600;
                    color: #0a0f16;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .description {
                    font-size: 24px;
                    font-weight: 400;
                    color: #676a71;
                    margin-top: 8px;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .day {
                    margin-top: 16px;
                    font-size: 24px;
                    font-weight: 400;
                    color: #cecfd0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/homePage/index.vue